import { Category } from "../../contracts/Category";
import {
  choiceComponentWithId,
  stringForRichTextComponentWithId,
  stringForSingleLineComponentWithId,
} from "../../mapper/api-mappers";
import { DataMapper } from "..";

export default function FetchFolderToCategory(data: any): Category {
  const mapper = DataMapper();
  const firstSeoChunk = data.meta?.content?.chunks[0];
  const dto: Category = {
    name: data.name,
    path: data.path,
    title:
      stringForSingleLineComponentWithId(data.components, "title") ||
      data.name!,
    description:
      stringForRichTextComponentWithId(data.components, "description") ||
      data.name!,
    grids: data.hero?.content?.grids
      ? data.hero.content.grids.map((grid: any) => ({
          id: grid.id,
          rows: grid.rows,
        }))
      : [],
    seo: mapper.API.Object.APIMetaSEOComponentToSEO(firstSeoChunk),
    thumbnail: data.components.find(
      (component: any) => component.id === "thumbnail",
    )?.content,
    topMenu: data.components.find(
      (component: any) => component.id === "top-menu",
    )?.content,
    subMenu: data.components.find(
      (component: any) => component.id === "sub-menu",
    )?.content,
    intro: data.components.find((component: any) => component.id === "intro")
      ?.content,
  };

  return dto;
}
